import { Image, Text } from '@chakra-ui/react';
import usePeCompanyColor from 'hooks/modules/pe/usePeCompanyColor';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';

interface Props {
  company: PeCompanyDetail;
}

const PeCompanyPreviewSection: FC<Props> = ({ company }) => {
  const bgColor = usePeCompanyColor(company.color, company.gradientColor);

  return (
    <AppCard
      w="full"
      background={bgColor}
      h="130px"
      pt="30px"
      pb="20px"
      px="20px"
      position="relative"
    >
      {company.logoSrc && (
        <Image
          position="absolute"
          src={company.logoSrc}
          right="30px"
          top="30px"
          w="100px"
          h="100px"
        />
      )}
      <Text color="white" fontWeight={700} fontSize="30px">
        {company.name}
      </Text>
    </AppCard>
  );
};

export default PeCompanyPreviewSection;
